(function () {
	const header = () => {
		const megaMenuLinks = document.querySelectorAll(".list-menu--megamenu");
		let activeMenu = null;
		let isInsideMegaMenu = false;
		let closeTimeout = null;
		
		// Ensure all menus are closed on initialization
		megaMenuLinks.forEach((menu) => {
			menu.classList.remove("list-menu--megamenu-visible");
		});
		
		const closeMenu = (menuItem) => {
			menuItem.classList.remove("list-menu--megamenu-visible");
			if (activeMenu === menuItem) {
				activeMenu = null;
			}
		};
		
		const closeAllMenus = () => {
			megaMenuLinks.forEach((menu) => {
				menu.classList.remove("list-menu--megamenu-visible");
			});
			activeMenu = null;
		};
		
		const openMenu = (menuItem) => {
			// Clear any pending close
			if (closeTimeout) {
				clearTimeout(closeTimeout);
				closeTimeout = null;
			}
			
			// If we're inside a mega menu and trying to open a different one, ignore
			if (isInsideMegaMenu && activeMenu && activeMenu !== menuItem) {
				return;
			}
			
			// Close other menus first
			megaMenuLinks.forEach((menu) => {
				if (menu !== menuItem) {
					menu.classList.remove("list-menu--megamenu-visible");
				}
			});
			
			// Open this menu
			menuItem.classList.add("list-menu--megamenu-visible");
			activeMenu = menuItem;
		};
		
		const scheduleClose = () => {
			if (closeTimeout) {
				clearTimeout(closeTimeout);
			}
			closeTimeout = setTimeout(() => {
				if (!isInsideMegaMenu && activeMenu) {
					closeMenu(activeMenu);
				}
			}, 200);
		};
		
		megaMenuLinks.forEach((menuItem) => {
			const trigger = menuItem.querySelector(".header__menu-item");
			const megaMenu = menuItem.querySelector(".mega-menu");
			
			// Open menu when hovering over the trigger (nav item in header)
			if (trigger) {
				trigger.addEventListener("mouseenter", () => {
					openMenu(menuItem);
				});
				
				trigger.addEventListener("mouseleave", (e) => {
					const relatedTarget = e.relatedTarget;
					// Check if we're moving to the mega menu content
					if (relatedTarget && megaMenu && megaMenu.contains(relatedTarget)) {
						// Moving into the mega menu, keep it open
						isInsideMegaMenu = true;
						return;
					}
					// Not moving into mega menu, schedule close
					if (!isInsideMegaMenu) {
						scheduleClose();
					}
				});
			}
			
			// Mega menu content hover - keep menu open when hovering over it
			if (megaMenu) {
				megaMenu.addEventListener("mouseenter", () => {
					if (closeTimeout) {
						clearTimeout(closeTimeout);
						closeTimeout = null;
					}
					isInsideMegaMenu = true;
					// Keep menu open when hovering over mega menu content
					if (!activeMenu || activeMenu === menuItem) {
						openMenu(menuItem);
					}
				});
				
				megaMenu.addEventListener("mouseleave", (e) => {
					isInsideMegaMenu = false;
					
					// Check if we're moving to the trigger of the same menu
					const relatedTarget = e.relatedTarget;
					if (relatedTarget) {
						const parentMenuItem = relatedTarget.closest(".list-menu--megamenu");
						if (parentMenuItem === menuItem) {
							// Still in the same menu item, don't close
							return;
						}
					}
					
					scheduleClose();
				});
			}
			
			// Menu item (li) leave - handle when leaving the entire menu item area
			menuItem.addEventListener("mouseleave", (e) => {
				const relatedTarget = e.relatedTarget;
				
				// Check if moving to the mega menu content
				if (relatedTarget && relatedTarget.closest) {
					const targetMegaMenu = relatedTarget.closest(".mega-menu");
					const targetMenuItem = relatedTarget.closest(".list-menu--megamenu");
					
					if (targetMegaMenu && targetMenuItem === menuItem) {
						// Moving into our own mega menu, keep open
						isInsideMegaMenu = true;
						return;
					}
					
					if (targetMenuItem && targetMenuItem !== menuItem) {
						// Moving to another menu item - let that one handle opening
						isInsideMegaMenu = false;
					}
				}
				
				if (!isInsideMegaMenu) {
					scheduleClose();
				}
			});
		});

		// Handle 3-level mega menu hover behavior
		const megaMenuColumns = document.querySelectorAll(".mega-menu__columns");
		
		megaMenuColumns.forEach((columns) => {
			const isThreeLevel = columns.getAttribute("data-three-level") === "true";
			
			// Level 1 items and their submenus
			const level1Items = columns.querySelectorAll(".mega-menu__list-item[data-level='1']");
			const level2Submenus = columns.querySelectorAll(".mega-menu__submenu--level-2");
			const level2Container = columns.querySelector(".mega-menu__submenu-container--level-2");
			
			// Level 2 items and their submenus (for 3-level menus)
			const level3Submenus = columns.querySelectorAll(".mega-menu__submenu--level-3");
			const level3Container = columns.querySelector(".mega-menu__submenu-container--level-3");
			const level2ListItems = level2Container?.querySelectorAll(".mega-menu__submenu-list-item[data-level='2']") || [];
			
			// Helper function to show/hide submenus
			const showSubmenu = (submenu) => {
				submenu.style.opacity = "1";
				submenu.style.visibility = "visible";
				submenu.style.pointerEvents = "all";
			};
			
			const hideSubmenu = (submenu) => {
				submenu.style.opacity = "0";
				submenu.style.visibility = "hidden";
				submenu.style.pointerEvents = "none";
			};
			
			// Helper to set active state on level 1 items
			const setActiveLevel1 = (activeHandle) => {
				level1Items.forEach((item) => {
					const link = item.querySelector(".mega-menu__link[data-link-handle]");
					if (link && link.getAttribute("data-link-handle") === activeHandle) {
						item.classList.add("is-active");
					} else {
						item.classList.remove("is-active");
					}
				});
			};
			
			// Helper to set active state on level 2 items
			const setActiveLevel2 = (activeHandle) => {
				level2ListItems.forEach((item) => {
					const link = item.querySelector("[data-link-handle]");
					if (link && link.getAttribute("data-link-handle") === activeHandle) {
						item.classList.add("is-active");
					} else {
						item.classList.remove("is-active");
					}
				});
			};
			
			// Get the first level 1 item's handle
			const getFirstLevel1Handle = () => {
				const firstLevel1Link = level1Items[0]?.querySelector(".mega-menu__link[data-link-handle]");
				return firstLevel1Link?.getAttribute("data-link-handle");
			};
			
			// Get first level 2 handle for a given level 1
			const getFirstLevel2Handle = (level1Handle) => {
				const level2Submenu = columns.querySelector(`.mega-menu__submenu--level-2[data-parent-link="${level1Handle}"]`);
				if (!level2Submenu) return null;
				const firstLevel2Link = level2Submenu.querySelector("[data-link-handle]");
				return firstLevel2Link?.getAttribute("data-link-handle");
			};
			
			// Show level 2 submenu for a given level 1 handle
			const showLevel2For = (level1Handle) => {
				level2Submenus.forEach((submenu) => {
					if (submenu.getAttribute("data-parent-link") === level1Handle) {
						showSubmenu(submenu);
					} else {
						hideSubmenu(submenu);
					}
				});
				setActiveLevel1(level1Handle);
			};
			
			// Show first level 3 for a given level 1
			const showFirstLevel3For = (level1Handle) => {
				let foundFirst = false;
				let firstLevel2Handle = null;
				level3Submenus.forEach((submenu) => {
					const grandparentLink = submenu.getAttribute("data-grandparent-link");
					if (grandparentLink === level1Handle && !foundFirst) {
						showSubmenu(submenu);
						firstLevel2Handle = submenu.getAttribute("data-parent-link");
						foundFirst = true;
					} else {
						hideSubmenu(submenu);
					}
				});
				if (firstLevel2Handle) {
					setActiveLevel2(firstLevel2Handle);
				} else {
					// If no level 3, set first level 2 item as active
					const firstHandle = getFirstLevel2Handle(level1Handle);
					if (firstHandle) {
						setActiveLevel2(firstHandle);
					}
				}
			};
			
			// Show level 3 submenu for a given level 2 handle
			const showLevel3For = (level2Handle, level1Handle) => {
				level3Submenus.forEach((submenu) => {
					const parentLink = submenu.getAttribute("data-parent-link");
					const grandparentLink = submenu.getAttribute("data-grandparent-link");
					if (parentLink === level2Handle && grandparentLink === level1Handle) {
						showSubmenu(submenu);
					} else {
						hideSubmenu(submenu);
					}
				});
				setActiveLevel2(level2Handle);
			};
			
			// Initialize: show first level 1's submenus
			const firstLevel1Handle = getFirstLevel1Handle();
			if (firstLevel1Handle) {
				showLevel2For(firstLevel1Handle);
				if (isThreeLevel) {
					showFirstLevel3For(firstLevel1Handle);
				}
			}
			
			// Level 1 hover behavior
			level1Items.forEach((listItem) => {
				const link = listItem.querySelector(".mega-menu__link[data-link-handle]");
				if (!link) return;
				
				const linkHandle = link.getAttribute("data-link-handle");
				
				listItem.addEventListener("mouseenter", () => {
					showLevel2For(linkHandle);
					
					if (isThreeLevel) {
						showFirstLevel3For(linkHandle);
					}
				});
			});
			
			// Level 2 hover behavior (for showing level 3)
			if (isThreeLevel && level2Container) {
				level2ListItems.forEach((listItem) => {
					const link = listItem.querySelector("[data-link-handle]");
					if (!link) return;
					
					const linkHandle = link.getAttribute("data-link-handle");
					
					listItem.addEventListener("mouseenter", () => {
						// Find the grandparent (level 1) handle
						const parentSubmenu = listItem.closest(".mega-menu__submenu--level-2");
						const level1Handle = parentSubmenu?.getAttribute("data-parent-link");
						
						if (level1Handle) {
							showLevel3For(linkHandle, level1Handle);
						}
					});
				});
			}
		});
	};

	document.addEventListener("shopify:section:load", header);

	header();
})();
